import axios from "axios";

// Resolve backend URL at runtime so the frontend always talks to the SAME
// origin it is being served from. This avoids stale build-time URLs (e.g.
// the platform baking "maritime-tickets.emergent.host" into the bundle while
// the site is served from adalardatatil.com).
//
// Falls back to REACT_APP_BACKEND_URL only when window is unavailable (SSR).
const RUNTIME_ORIGIN = (typeof window !== "undefined" && window.location && window.location.origin) || "";
const BACKEND_URL = RUNTIME_ORIGIN || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });
export default http;

export function fmtError(detail) {
  if (detail == null) return "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}
